module.exports = __webpack_public_path__ + "img/about-values-03.jpg?2ddaeee8b1355cd174853ca1a401f1c4";